import microuniversoApi from "app/api/microuniversoApi";
import {
    FiltrosListarTemplateSeguranca,
    PermissoesImpressao,
    RespostaModalEnviarEmail,
    RespostaModalImprimir
} from "app/types/modalImprimir/RespostaModalImprimir";
import { tratamentoErroPadrao } from "app/use-cases";
import globalMU from "globalMU";
import React, { memo, useCallback, useEffect, useEffectEvent, useRef, useState } from "react";
import { ModalEnviarEmailContainer } from "./modalEnviarEmail/modalEnviarEmailContainer";
import { ModalImprimir } from "./modalImprimir";
import { ModalEnviarWhatsappContainer } from "./modalEnviarWhatsapp/modalEnviarWhatsappContainer";
import { OrcamentoApi } from "app/api/classes/OrcamentoApi";
import { Vendedor } from "app/types/Vendedor"
import { ParametroPorItem } from "app/types/Parametro";
import { obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";
import { IOrcamento } from "app/types/IOrcamento";
import { EnumTiposMuWhatsapp } from "app/types/Whatsapp/EnumTiposMuWhatsapp";
import { useAppSelector } from "app/redux/hooks";
//import {obterPermissao} from "../../../../use-cases/obterPermissao";

export type ModalImprimirContainerProps = {
    urlBase?: string;
    parametrosTemplate?: ParametrosTemplate[];
    exibirModalImprimir?: boolean;
    permissaoSenhaModalImprimir?: PermissaoSenhaModalImprimirProps;
    filtrosTemplates: FiltrosListarTemplateSeguranca;
    permissoes: PermissoesImpressao;
    nomeArquivoWord?: string;
    idOrcamento?: number;
    vendedor?: Vendedor;
    onClose?: () => void;
}

export type PermissaoSenhaModalImprimirProps = {
    senhaSolicitar?: string // 440413
    senhaSolicitarDica?: string // 440413
    senhaTextoAdicional?: string //450413
}


export type ParametrosTemplate = {
    nome: string;
    valor: string[] | number[];
}

export const montarUrl = (urlModeloTemplate: string, parametrosTemplate: ParametrosTemplate[], urlBase: string): string => {
    let urlParametrosTemplate: string = "";
    for (let i: number = 0; i < parametrosTemplate?.length; i++) {
        let valores: string[] | number[] = parametrosTemplate[i].valor;
        urlParametrosTemplate += parametrosTemplate[i].nome + "=" + (Array.isArray(valores) ? valores.join(',') : valores) + "&";
    }
    const abaId = sessionStorage.getItem('aba_id');
    const abaParam = abaId ? ("&XAbaId=" + encodeURIComponent(abaId)) : "";
    return urlBase + '?' + urlParametrosTemplate + "urlTemplate=" + urlModeloTemplate + abaParam
}

export const ModalImprimirContainer = memo((props: ModalImprimirContainerProps) => {
    const [permissoes, setPermissoes] = useState<PermissoesImpressao>(props.permissoes)
    const [exibirModalEmail, setExibirModalEmail] = useState<boolean>(false);
    const [exibirModalWhatsapp, setExibirModalWhatsapp] = useState<boolean>(false);
    const [templateEnviarEmail, setTemplateEnviarEmail] = useState<RespostaModalImprimir>();
    const [dadoslistarTemplateSeguranca, setDadoslistarTemplateSeguranca] = useState<RespostaModalImprimir[]>();
    const [pedirSenha, setPedirSenha] = useState<boolean>(undefined)
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([]);
    const [vendedorAutenticado, setVendedorAutenticado] = useState<Vendedor>(null);
    const isMounted = useRef<boolean>(true);
    const hasRunParametros = useRef(false);
    const [carregando, setCarregando] = useState<boolean>(true)
    const [dadosEnvio, setDadosEnvio] = useState<RespostaModalEnviarEmail>(null);

    useEffect(() => () => { isMounted.current = false }, [])

    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);

    const valorParametroPorFilial = useCallback((nome: string) =>
        parametrosPorFilial.find((p) => p.Nome == nome)?.Valor,
        [parametrosPorFilial]
    );

    const listarTemplateSeguranca = async (filtros: FiltrosListarTemplateSeguranca) => {
        try {
            const resposta: RespostaModalImprimir[] = await microuniversoApi.Seguranca.listar(
                filtros
            );

            if (!isMounted.current) return

            setDadoslistarTemplateSeguranca(resposta);

            // Dentro do try: antes o `resposta` era lido DEPOIS do catch (com `var`, que vaza da
            // chave), então uma falha na API caía no tratamentoErroPadrao e AINDA por cima exibia
            // "Não existe modelo cadastrado" — dois avisos para o mesmo problema.
            if (globalMU.isNull(resposta)) {
                globalMU.showErrorMessage("Não existe modelo cadastrado para esta ação");
            }
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
        }
    }

    const carregarDadosEnvio = async () => {
        const dados = await microuniversoApi.Orcamento.ObterInformacoesEnvioWhatsappClientePorNumero(
            props.idOrcamento
        );

        if (!isMounted.current) return

        setDadosEnvio({
            ...dados, NumeroPedido: props.idOrcamento,
        })
    }

    const onImprimirDados = useCallback((urlModeloTemplate: string) => {
        globalMU.blockUI();
        const urlImprimirTemplate: string = montarUrl(urlModeloTemplate, props.parametrosTemplate, props.urlBase);
        try {
            window.open(urlImprimirTemplate, "_blank", "Impressão de Relatório");
        } catch (erro) {
            tratamentoErroPadrao(erro);
        }
        finally {
            globalMU.unblockUI()
        }
    }, [props.parametrosTemplate, props.urlBase])

    const onMandarEmail = useCallback((dado: RespostaModalImprimir) => {
        setTemplateEnviarEmail(dado);
        setExibirModalEmail(true);
    }, [])

    const onMandarWhatsapp = useCallback((dado: RespostaModalImprimir) => {
        if (valorParametroPorFilial("METODO_ENVIO_MENSAGEM_WHATSAPP") == EnumTiposMuWhatsapp.API.toString()
            || valorParametroPorFilial("METODO_ENVIO_MENSAGEM_WHATSAPP") == EnumTiposMuWhatsapp.BOT.toString()) {

            setTemplateEnviarEmail(dado);
            setExibirModalWhatsapp(true);
        }
        else {
            globalMU.showWarnMessage("Configure o parâmetro [Método de envio de mensagens para WhatsApp] como 'API' ou 'BOT' para enviar mensagens via WhatsApp.")
        }
    }, [valorParametroPorFilial])

    const linkWord = useCallback((urlModeloTemplate: string): string => {
        return montarUrl(urlModeloTemplate, props.parametrosTemplate, props.urlBase).replace('?', 'Word?');
    }, [props.parametrosTemplate, props.urlBase])

    const onSenhaValidada = useCallback(async (senhaValida: boolean, senha?: string) => { // 450413
        if (senhaValida) {
            await microuniversoApi.Orcamento.GerarHistoricoLiberacaoPendencia(
                props.idOrcamento,
                "Liberação de impressão do orçamento com desconto acima do permitido",
                senha,
                "LIBORCDESCONTO"
            ) // 450413

            if (!isMounted.current) return

            setPedirSenha(false)  // 450413 - para mostrar lista de modelos de impressao
        }
    }, [props.idOrcamento])

    const fecharModalEmail = useCallback(() => setExibirModalEmail(false), [])
    const fecharModalWhatsapp = useCallback(() => setExibirModalWhatsapp(false), [])

    const atualizarParametros = async () => {
        try {
            const parametrosFilial = await obterParametrosPorOidItem({
                nomes: [
                    "METODO_ENVIO_MENSAGEM_WHATSAPP",

                ],
                oidItem: vendedorAutenticado?.OidFilial ?? props.vendedor.OidFilial ?? orcamento.OidFilialOrcamento,
            });

            if (!isMounted.current) return

            setParametrosPorFilial(parametrosFilial);

        } catch (e) {
            tratamentoErroPadrao(e);
        }
    };

    const obterVendedorAutenticado = async () => {
        try {
            const vendedorAutenticadoResponse: Vendedor =
                (await microuniversoApi.Vendedor.ObterVendedorAutenticado())

            if (isMounted.current) {
                setVendedorAutenticado(vendedorAutenticadoResponse ?? props.vendedor);
            }

            return vendedorAutenticadoResponse;
        } catch (e) {
            tratamentoErroPadrao(e);
            return null;
        }
    }

    // Os corpos abaixo são useEffectEvent: leem props/estado SEMPRE no valor mais recente sem que
    // isso entre na lista de deps. É o que o código já queria — as listas de deps eram propositalmente
    // curtas (só o gatilho) enquanto o corpo lia bem mais coisa, que era leitura presa ao closure.

    // Abrir/fechar o modal: recarrega os modelos e ressincroniza permissões e dados de envio.
    const _aoAlternarExibicaoDoModal = useEffectEvent(() => {
        globalMU.unblockUI();
        setPermissoes(props.permissoes)

        if (!props.exibirModalImprimir) {
            setDadosEnvio(null);
            return
        }

        listarTemplateSeguranca(props.filtrosTemplates);

        if (props.idOrcamento != undefined && props.idOrcamento != null && props.idOrcamento > 0) {
            carregarDadosEnvio();
        }
    })

    // Eram DOIS efeitos com a mesma dep `[props.exibirModalImprimir]`, um logo abaixo do outro.
    useEffect(() => {
        _aoAlternarExibicaoDoModal()
    }, [props.exibirModalImprimir])

    const _liberarTelaQuandoModelosCarregarem = useEffectEvent(() => {
        if (dadoslistarTemplateSeguranca != undefined && dadoslistarTemplateSeguranca !== null && dadoslistarTemplateSeguranca.length > 0
            && permissoes != undefined && permissoes != null
        ) {
            globalMU.unblockUI()
            setPedirSenha(props.permissaoSenhaModalImprimir?.senhaSolicitar != undefined && props.permissaoSenhaModalImprimir?.senhaSolicitar != "") // 450413
            setCarregando(false)
        }
    })

    useEffect(() => {
        _liberarTelaQuandoModelosCarregarem()
    }, [dadoslistarTemplateSeguranca, permissoes])

    const _carregarParametrosDaFilialUmaVez = useEffectEvent(() => {
        if (!hasRunParametros.current && (vendedorAutenticado || props.vendedor)) {
            hasRunParametros.current = true;
            atualizarParametros();
        }
    })

    useEffect(() => {
        _carregarParametrosDaFilialUmaVez()
    }, [vendedorAutenticado]);

    const _obterVendedorAutenticado = useEffectEvent(() => {
        obterVendedorAutenticado();
    })

    useEffect(() => {
        _obterVendedorAutenticado()
    }, [props.exibirModalImprimir, exibirModalWhatsapp]);

    return (
        carregando
            ? <></>
            :
            <>
                {props.exibirModalImprimir && dadoslistarTemplateSeguranca != undefined
                    && dadoslistarTemplateSeguranca !== null && dadoslistarTemplateSeguranca.length > 0
                    &&
                    <ModalImprimir
                        permitidoEmail={permissoes.permitidoEnviarEmail}
                        permitidoWord={permissoes.permitidoImprimirWord}
                        dados={dadoslistarTemplateSeguranca}
                        nomeArquivoWord={props.nomeArquivoWord}
                        permissaoSenhaModalImprimir={props.permissaoSenhaModalImprimir} // //450413
                        // senhaSolicitar={props.senhaSolicitar}//450413
                        // senhaSolicitarDica={props.senhaSolicitarDica}//450413
                        // senhaTextoAdicional={props.senhaTextoAdicional}//450413
                        pedirSenha={pedirSenha}//450413
                        onSenhaValidada={onSenhaValidada}//450413
                        onClose={props.onClose}
                        onImprimir={onImprimirDados}
                        onEmail={onMandarEmail}
                        onWhatsapp={onMandarWhatsapp}
                        linkWord={linkWord}
                    />
                }
                {exibirModalEmail && // 467121
                    <ModalEnviarEmailContainer
                        permitidoAlterarMensagem={permissoes.permitidoAlterarMensagemEmail}
                        permitidoAlterarAssunto={permissoes.permitidoAlterarAssuntoEmail}
                        permitidoCopia={permissoes.permitidoAlterarCopiaEmail}
                        permitidoCopiaOculta={permissoes.permitidoAlterarCopiaOcultaEmail}
                        exibirModalEmail={exibirModalEmail}
                        template={templateEnviarEmail}
                        idOrcamento={props.idOrcamento}
                        permitidoAnexar={permissoes.permitidoAnexarEmail}
                        parametrosTemplate={props.parametrosTemplate}
                        onClose={fecharModalEmail}
                    />
                }
                {exibirModalWhatsapp && // 467121
                    <ModalEnviarWhatsappContainer
                        permitidoAlterarMensagem={permissoes.permitidoAlterarMensagemEmail}
                        permitidoAlterarAssunto={permissoes.permitidoAlterarAssuntoEmail}
                        permitidoCopia={permissoes.permitidoAlterarCopiaEmail}
                        permitidoCopiaOculta={permissoes.permitidoAlterarCopiaOcultaEmail}
                        exibirModalWhatsapp={exibirModalWhatsapp}
                        template={templateEnviarEmail}
                        idOrcamento={props.idOrcamento}
                        permitidoAnexar={permissoes.permitidoAnexarEmail}
                        parametrosTemplate={props.parametrosTemplate}
                        onClose={fecharModalWhatsapp}
                        vendedor={props.vendedor}
                        vendedorAutenticado={vendedorAutenticado}
                        dadosEnvio={dadosEnvio}
                    />
                }

            </>
    );
})
